<template>
  <div>
    <base-header type="gradient-success" class="pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <div class="row">
        <div class="col-xl-3 col-lg-6">
          <stats-card
            title="ลูกค้าพรบ."
            type="gradient-red"
            :sub-title="dashboard.data1 + ' คน'"
            icon="ni ni-active-40"
            class="mb-4 mb-xl-0"
          >
            <!-- <template slot="footer">
              <span class="text-success mr-2"
                ><i class="fa fa-arrow-up"></i> 3.48%</span
              >
              <span class="text-nowrap">Since last month</span>
            </template> -->
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card
            title="ลูกค้าประกัน"
            type="gradient-orange"
            :sub-title="dashboard.data2 + ' คน'"
            icon="ni ni-chart-pie-35"
            class="mb-4 mb-xl-0"
          >
            <!-- <template slot="footer">
              <span class="text-success mr-2"
                ><i class="fa fa-arrow-up"></i> 12.18%</span
              >
              <span class="text-nowrap">Since last month</span>
            </template> -->
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card
            title="ลูกค้าพรบ. ที่ต้องต่ออายุ"
            type="gradient-green"
            :sub-title="dashboard.data3 + ' คน'"
            icon="ni ni-money-coins"
            class="mb-4 mb-xl-0"
          >
            <!-- <template slot="footer">
              <span class="text-danger mr-2"
                ><i class="fa fa-arrow-down"></i> 5.72%</span
              >
              <span class="text-nowrap">Since last month</span>
            </template> -->
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card
            title="ลูกค้าประกัน ที่ต้องต่ออายุ"
            type="gradient-info"
            :sub-title="dashboard.data4 + ' คน'"
            icon="ni ni-chart-bar-32"
            class="mb-4 mb-xl-0"
          >
            <!-- <template slot="footer">
              <span class="text-success mr-2"
                ><i class="fa fa-arrow-up"></i> 54.8%</span
              >
              <span class="text-nowrap">Since last month</span>
            </template> -->
          </stats-card>
        </div>
      </div>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12 mb-4 mb-md-5 mb-xl-0 text-center">
          <h1 class="text-white mt-md-3">ค้นหาข้อมูล</h1>
          <form role="form" v-on:submit="search">
            <div class="search row">
              <div class="dropdown mb-3">
                <b-dropdown
                  id="dropdown"
                  offset="100"
                  :text="type[selectedType].name"
                  class="m-0 mr-2"
                >
                  <b-dropdown-item
                    v-for="(t, index) in type"
                    :key="t.id"
                    :value="t.name"
                    @click="selectType(t.id, index)"
                    >{{ t.name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <div class="col-md-4 pt-0 pl-0 pr-2">
                <base-input
                  alternative=""
                  label=""
                  placeholder="ข้อมูลที่ต้องการค้นหา"
                  input-classes="form-control-alternative"
                  v-model="keyword"
                />
              </div>
              <input
                type="submit"
                class="btn btn-primary mt--2 mt-md-0 mb-md-4"
                value="ค้นหาข้อมูล"
              />
            </div>
          </form>
        </div>
      </div>
      <!-- End charts-->

      <!--Tables-->
      <div class="row mt-2" :class="!isSearched ? 'none' : ''">
        <div class="col-xl-12 mb-5">
          <h6 class="heading-small text-muted">พรบ.</h6>
          <WSUTable
            :title="'ผลการค้นหา ของ ' + keywordToShow"
            :wsus.sync="wsus"
          ></WSUTable>
          <h6 class="heading-small text-muted mt-3">ประกัน</h6>
          <InsuranceTable
            :title="'ผลการค้นหา ของ ' + keywordToShow"
            :insurances.sync="insurances"
          ></InsuranceTable>
          <h6 class="heading-small text-muted mt-3">เอกสาร</h6>
          <document-table
            :title="'ผลการค้นหา ของ ' + keywordToShow"
            :documents.sync="documents"
          ></document-table>
          <h6 class="heading-small text-muted mt-3">ใบเสร็จ</h6>
          <receipt-table
            :title="'ผลการค้นหา ของ ' + keywordToShow"
            :receipts.sync="receipts"
          ></receipt-table>
        </div>
      </div>
      <!--End tables-->
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import kickMixin from "../mixins/kickMixin";
import WSUTable from "./Tables/DashboardWSUTable";
import InsuranceTable from "./Tables/DashboardInsuranceTable";
import DocumentTable from "./Tables/DashboardDocumentTable";
import ReceiptTable from "./Tables/DashboardReceiptTable";
// import PageVisitsTable from "./Dashboard/PageVisitsTable";
import Dropdown from "bootstrap-vue/src/components/dropdown";

Vue.use(Dropdown);

export default {
  mixins: [kickMixin],
  components: {
    // PageVisitsTable,
    WSUTable,
    InsuranceTable,
    DocumentTable,
    ReceiptTable,
  },
  data() {
    return {
      isSearched: false,
      keywordToShow: "",
      lvl: 0,
      keyword: "",
      dashboard: {
        data1: "",
        data2: "",
        data3: "",
        data4: "",
      },
      selectedType: 0,
      type: [
        { id: 1, name: "เลขทะเบียน" },
        { id: 2, name: "เลขตัวถัง" },
        { id: 3, name: "ชื่อสกุล" },
      ],
      wsus: [],
      insurances: [],
      documents: [],
      receipts: [],
      paginate: {
        total: 0,
        page: 1,
        perPage: 30,
      },
    };
  },
  methods: {
    selectType: function(id, index) {
      var localApp = this;
      localApp.selectedType = index;
    },
    loadDashboard: function() {
      var localApp = this;
      axios
        .get("https://api.sd5525.com/api/dashboard", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.dashboard.data1 = response.data.wsuCount.toLocaleString();
            localApp.dashboard.data2 = response.data.insuranceCount.toLocaleString();
            localApp.dashboard.data3 = response.data.wsuExpiredCount.toLocaleString();
            localApp.dashboard.data4 = response.data.insuranceExpiredCount.toLocaleString();
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    search: async function(e) {
      let localApp = this;
      if (localApp.keyword !== "") {
        e.preventDefault();

        localApp.keywordToShow = localApp.keyword;
        localApp.isSearched = false;

        let url = "";
        switch (localApp.selectedType) {
          case 0: {
            url =
              "https://api.sd5525.com/api/dashboard/search/license/q?keyword=";
            break;
          }
          case 1: {
            url = "https://api.sd5525.com/api/dashboard/search/body/q?keyword=";
            break;
          }
          case 2: {
            url = "https://api.sd5525.com/api/dashboard/search/name/q?keyword=";
            break;
          }
        }

        await axios
          .get(
            url + localApp.keyword,
            // + "&page=" +
            // localApp.paginate.page,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
              },
            }
          )
          .then(function(response) {
            localApp.isSearched = true;
            localApp.wsus = response.data.wsus;
            localApp.insurances = response.data.insurances;
            localApp.documents = response.data.documents;
            localApp.receipts = response.data.receipts;
            // localApp.paginate.total = response.data.data.total;
          })
          .catch(function(error) {
            alert(error);
          });
      } else {
        alert("กรุณาใส่ข้อมูลที่ต้องการค้นหา");
      }
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.lvl = localStorage.level;
      if (this.lvl === "999" || this.lvl === "0") {
        this.loadDashboard();
      } else {
        let routeData = this.$router.resolve({
          path: "/customerWsu" ,
        });
        location.replace(routeData.href);
      }
    }
  },
};
</script>
<style>
.search {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
#dropdown {
  color: #32325d !important;
}

h5,
.h5 {
  font-size: 1.05rem !important;
}

h2,
.h2 {
  font-size: 1.4rem !important;
}

h1,
.h1 {
  font-size: 1.8rem;
}

.form-control,
.btn {
  font-size: 1rem;
}
</style>
